// Subscription data is managed by the server, never by a settings form.
export function editableConfig(config) {
  const readOnly = new Set(["id", "created_at", "updated_at", "trial_ends_at", "paid_at", "activated_at", "payment_started_at", "last_payment_status"]);
  return Object.fromEntries(Object.entries(config).filter(([key]) =>
    !readOnly.has(key) && !/^(subscription_|mollie_|billing_)/.test(key)));
}
